type Props = {
    title: string;
    subtitle?: string;
    imageUrl?: string;
    imageAlt?: string;
}


export function HeroHeader({
                               title,
                               subtitle,
                               imageUrl = "https://images.pexels.com/photos/80454/tree-desert-namibia-dead-vlei-80454.jpeg",
                               imageAlt = "Hero Image"
                           }: Props) {
    return (
        <div className="bg-gradient-to-b from-[#1E2939] to-[#112E5C]">
            <div className="relative">
                <div className="mx-auto max-w-7xl">
                    <div className="relative z-10 lg:w-full lg:max-w-2xl">
                        <svg
                            viewBox="0 0 100 100"
                            preserveAspectRatio="none"
                            aria-hidden="true"
                            className="absolute inset-y-0 right-8 hidden h-full w-80 translate-x-1/2 transform lg:block"
                        >
                            <defs>
                                <linearGradient id="heroGradient" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0%" stopColor="#1E2939"/>
                                    <stop offset="100%" stopColor="#112E5C"/>
                                </linearGradient>
                            </defs>
                            <polygon points="0,0 90,0 50,100 0,100" fill="url(#heroGradient)"/>
                        </svg>

                        <div className="relative px-6 py-32 sm:py-40 lg:px-8 lg:py-26 lg:pr-0">
                            <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-xl">
                                <h1 className="text-5xl font-semibold tracking-tight text-pretty text-white sm:text-7xl">
                                    {title}
                                </h1>
                                {subtitle ? (
                                    <p className="mt-8 text-lg font-medium text-pretty text-gray-300 sm:text-xl/8">
                                        {subtitle}
                                    </p>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-gray-50 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
                    <img
                        alt={imageAlt}
                        src={imageUrl}
                        className="aspect-3/2 object-cover lg:aspect-auto lg:size-full"
                    />
                </div>
            </div>
        </div>
    );
}
